// Imagen AI integration translations - English
export default {
  generator: {
    title: 'AI Image Generator',
    tabTitle: 'AI Generate',
    pageTitle: 'AI Image Generator with Google Imagen',
    forEntity: 'Generate an image for',

    // Form fields
    prompt: 'Image Prompt',
    promptPlaceholder: 'Describe the image you want to generate...',
    negativePrompt: 'Negative Prompt',
    negativePromptPlaceholder: 'What to avoid: blurry, low quality, watermark...',
    description: 'Attachment Description',
    descriptionPlaceholder: 'Description for this attachment...',
    aspectRatio: 'Aspect Ratio',
    numberOfImages: 'Number of Images',
    safetyLevel: 'Safety Level',
    autoAttach: 'Automatically attach to entity',
    enhancePrompt: 'Enhance prompt with AI context',

    // Actions
    generate: 'Generate with AI',
    generating: 'Generating...',
    quickPrompt: 'Add Quality Terms',
    reset: 'Reset',
    showAdvanced: 'Show Advanced',
    hideAdvanced: 'Hide Advanced',
    generatedImages: 'Generated Images',

    // Info
    info: 'Google Imagen generates high-quality images from text descriptions using advanced AI.',
    feature1: 'High-quality image generation',
    feature2: 'Multiple aspect ratios',
    feature3: 'Built-in safety filters'
  },

  // Success messages
  success: {
    generated: 'Successfully generated {{count}} image(s)',
    entityGenerated: 'Generated {{count}} image(s) for {{entity}}',
    attached: 'AI-generated image successfully attached'
  },

  // Error messages
  errors: {
    promptRequired: 'Please enter a prompt to generate an image',
    promptRequiredWhenEnhanceDisabled: 'A prompt is required when AI enhancement is disabled',
    generationFailed: 'Failed to generate image',
    invalidEntity: 'Invalid entity type or ID',
    configLoadFailed: 'Failed to load Imagen configuration'
  },

  // Info messages
  info: {
    processing: 'Your image is being generated with Google Imagen...',
    qualityNote: 'Higher quality settings may take longer to generate'
  }
};
